import SmoothScroll from './components/SmoothScroll';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import WhyWe from './components/WhyWe';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <SmoothScroll>
      <div className="min-h-[100%] font-inter antialiased font-overused-grotesk-book text-[16px] text-opacity-[100%] text-[#ffffff] bg-[color:var(--692a16a2011e6)] w-[100%] ml-[auto] mr-[auto]">
        <div className="contents">
          <Header />
          <Hero />
          <Services />
          <WhyUs />
          <WhyWe />
          <Contact />
          <Footer />
        </div>
      </div>
    </SmoothScroll>
  );
}

export default App;
